import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '@rx-applications/shared/utils';
import { Currency } from '@rx-applications/shared/data-access';
import { GlobalTermsAndConditions } from '../models/globalTermsAndConditions.model';

@Injectable({ providedIn: 'root' })
export class UtilsBackend {
  private readonly apiUrl = `${this.httpService.webApiUrl}Utils/`;
  constructor(private http: HttpClient, private httpService: HttpService) {}

  getCurrencies(): Observable<Currency[]> {
    return this.http.get<Currency[]>(`${this.apiUrl}GetCurrencies`);
  }

  getTermsAndConditions(): Observable<GlobalTermsAndConditions> {
    return this.http.get<GlobalTermsAndConditions>(`${this.apiUrl}GetTermsAndConditions`);
  }
}
